/**
 * Customer status values
 */
export enum CustomerStatusEnum {
	/**
	 * Customer account is active and in good standing
	 */
	ACTIVE = 'active',
	/**
	 * Customer account is on hold due to other reasons
	 */
	ON_HOLD = 'on_hold',
	/**
	 * Customer account is suspended
	 */
	CLOSED = 'closed',
}
